exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-xs[data-v-5301b3a2]{padding:.125rem .25rem;font-size:.75rem;line-height:1;border-radius:.15rem}.table[data-v-5301b3a2]{width:100%;table-layout:fixed}.form-control[data-v-5301b3a2]{height:calc(1.8125rem + 2px);padding:.25rem .5rem;font-size:12px;line-height:1.5;border-radius:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5301b3a2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/BlockAccountsClientImport.vue
// module id = 200
// module chunks = 0